import React from 'react'
import {Modal} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import {find} from 'lodash'

import {replaceExpression} from '../utils'
import Collaboration from './Collaboration'
import PropTypes from 'prop-types'

export default class ConsultationAnswerModal extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      show: this.props.show,
      responses: this.props.responses
    }
  }

  buildResponses(responses, data, answerMap) {
    /**
     * Provides the Collaboration array, reusing the result of the call for collaborator's responses ordered by questions
     * @returns {*} extracts and merges all the responses per Collaborator
     */
    const collaboratorsWithSeveralResponses = () => {
      return Object.keys(responses).map(question => {
        /*extracts all the collaborators per question, and send the answer to a new inner array (answers)*/
        return responses[question]
          .map(person => Object.assign({...person}, {answers: [person.answer ? person.answer : {}]}, {answer: {}}))
      })
        .reduce((allCollaboratorsMerged, currentCollaboratorsPerQuestionArray) => [...allCollaboratorsMerged, ...currentCollaboratorsPerQuestionArray]) /*merges the arrays per questions, from the inner map processing*/
        .sort((collaboratorA, collaboratorB) => collaboratorA.id - collaboratorB.id)/*required for the reduction*/
        .reduce((allCollaboratorsSorted, currentCollaborator) => {
          const sizeAccumulator = allCollaboratorsSorted.length
          const lastCollaboratorLocation = sizeAccumulator - 1
          if (0 === sizeAccumulator || allCollaboratorsSorted[lastCollaboratorLocation].id !== currentCollaborator.id) {
            /*add just the non-duplicated entries, because its sorted by  ids*/
            allCollaboratorsSorted.push(currentCollaborator)
          } else { /*merge collaborators answers*/
            const collaboratorWithMergedResponses = Object.assign({...allCollaboratorsSorted[lastCollaboratorLocation]}, {answers: [...allCollaboratorsSorted[lastCollaboratorLocation].answers, ...currentCollaborator.answers]})
            allCollaboratorsSorted.splice(lastCollaboratorLocation, 1, collaboratorWithMergedResponses)
          }
          return allCollaboratorsSorted
        }, [])
    }

    const parseGroupedResponses = (answers) => {
      return answers.length < 1 ? ' ' : answers.map(answer => {
        const optionTextFound = answer.optionId ? find(data.options, o => o.id.toString() === answer.optionId.toString()) : ' '
        return replaceExpression(optionTextFound.optionText, answerMap)
          .concat(answer.stringValue ? /*just for numeric responses*/
            ' '.concat(answer.stringValue).concat(' ')
            : ' ')
      }).reduce((accumulatedResponses, currentResponse) => accumulatedResponses.concat('<p>').concat(currentResponse).concat('</p>'), ' ')
    }

    switch (data.optionType) {
      case 'NUMERIC' :
      case 'CHECKBOX':
        return collaboratorsWithSeveralResponses().map(collaborator => {
          const answerData = parseGroupedResponses(collaborator.answers)
          return {fullName: collaborator.firstName + ' ' + collaborator.lastName, response: answerData}
        })
      default:
        return Object.keys(responses).map(k => {
          return responses[k].map(person => {
            let answerData
            if ('0' === k) {
              //Group of collaborators who haven't reacted yet
              answerData = ''
            } else if (undefined !== person.answer && person.answer.stringValue) {
              //Extra and numeric questions
              answerData = person.answer.stringValue
            } else {
              const option = find(data.options, o => o.id.toString() === k)
              answerData = replaceExpression(option.optionText, answerMap)
            }
            return {fullName: person.firstName + ' ' + person.lastName, response: answerData}
          })
        }).reduce((a, b) => a.concat(b))
    }
  }

  render() {
    const { data, answermap } = this.props
    const { responses } = this.state
    const dataResponses = this.buildResponses(responses, data, answermap)
    const title = this.props.title

    function contentFormatter(cell, row) {
      return <span className="text" dangerouslySetInnerHTML={{__html: cell}}></span>
    }

    const columns = [
      {
        dataField: 'fullName',
        text: 'Medewerker',
        sort: true,
        headerFormatter: Collaboration.headerFormatter,
        formatter: Collaboration.contentFormatter
      },
      {
        dataField: 'response',
        text: 'Antwoord',
        sort: true,
        headerFormatter: Collaboration.headerFormatter,
        formatter: contentFormatter
      }
    ]

    return (
      <div key={title}>
        <Modal
          {...this.props}
          key={title}
          show={this.props.show}
          onHide={this.props.cancel}
          dialogClassName="custom-modal consultation-modal answer-modal table-page scans new-scan"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body key={'modal-body' + title}>
            <div className="user-table" key={'user-table' + title}>
              <BootstrapTable key={'user-table' + title}
                              keyField={this.props.keyfield}
                              data={dataResponses}
                              columns={columns}
                              bordered={false}
                              striped
                              hover
                              condensed
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

ConsultationAnswerModal.PopTypes = {
  show: PropTypes.bool,
  cancel: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/ConsultationAnswerModal.js